import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { featureQueryKeys } from "@/feature/data/featureQueryKeys";
import { APICollectionResponse, ErrorResponse } from "@reflag/shared/api";
import { PullRequest } from "@reflag/shared/featureAPI";

export function useFeaturePullRequestsData(featureId?: string | null) {
  const { appId } = useEnvironment();
  return useQuery<
    APICollectionResponse<PullRequest>,
    AxiosError<ErrorResponse>
  >({
    queryKey: featureQueryKeys.pullRequests(appId, featureId!),

    queryFn: () =>
      api
        .get<"/apps/:appId/features/:featureId/pull-requests">(
          `/apps/${appId}/features/${featureId}/pull-requests`,
        )
        .then((res) => res.data),
    enabled: !!appId && !!featureId,
    refetchOnWindowFocus: false,
    retry: false,
    refetchInterval: (query) => {
      if (query.state.status !== "success") {
        return false;
      } else if (query.state.data?.data && query.state.data?.data.length > 0) {
        const data = query.state.data.data;
        return data.some((item) => item.status === "creating") ? 3000 : false;
      }
    },
  });
}
